import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconFolder({
  extColor,
  isAutoscallable = false,
  sizeKey = '48x48',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.custom.lightGrey;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42 42"
      fill={fill}
    >
      <path d="M35 32H7V14.5H35M35 11H21L17.5 7.5H7C5.0575 7.5 3.5 9.0575 3.5 11V32C3.5 32.9283 3.86875 33.8185 4.52513 34.4749C5.1815 35.1313 6.07174 35.5 7 35.5H35C35.9283 35.5 36.8185 35.1313 37.4749 34.4749C38.1312 33.8185 38.5 32.9283 38.5 32V14.5C38.5 12.5575 36.925 11 35 11Z" />
    </svg>
  );
}
